import axios from "axios";
import { Cookies } from "react-cookie";
import { proxy } from "../config";
const cookie = new Cookies();

export const getForms = async (formType) => {
    const token = await cookie.get("token");
    return await axios.get(`${proxy}/form/data/${formType}`, {
        headers: { Authorization: token }
    });
};

export const getForm = async (id) => {
    const token = await cookie.get("token");
    return await axios.get(`${proxy}/form/form/${id}`, {
        headers: { Authorization: token }
    });
};

export const updateStatusForm = async (id, date, is_reject) => {
    const token = await cookie.get("token");
    return await axios.put(`${proxy}/form/update/${id}`, {
        date: date,
        is_reject: is_reject
    }, {
        headers: { Authorization: token }
    });
};

export const hideForm = async (id, formDate) => {
    const token = await cookie.get("token");
    return await axios.put(`${proxy}/form/hide/${id}`, formDate, {
        headers: { Authorization: token }
    });
};